module.exports = __webpack_public_path__ + "static/img/female-factory-960w.e4f307a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/female-factory-960w.jpeg
// module id = 220
// module chunks = 5